const blockReferenceButtons = document.querySelectorAll('[data-behaviour="show-references"]');

blockReferenceButtons.forEach(button => {
    button.addEventListener('click', function (e) {
        const section = this.closest('[data-ref="ref-section"]');
        section.classList.add('ref-block--active');
    });
});